/**
 * laylo-pastries.js
 * Click-to-enlarge lightbox for the Pastries gallery.
 *
 * Each gallery cell is a <button> (see laylo-pastries.liquid) carrying the
 * larger image URL + caption in data attributes. Clicking one populates the
 * single shared <dialog> and opens it with showModal() — native focus trap,
 * Escape-to-close, and focus-return to the trigger on close, all for free.
 *
 * Only one .laylo-pastries section can exist per page (schema "limit": 1),
 * so querying by class rather than scoping to a specific section instance
 * is safe and keeps this consistent with laylo-philosophy-stats.js's style.
 */
(function () {
  var section = document.querySelector('.laylo-pastries');
  if (!section) return;

  var dialog = section.querySelector('.laylo-pastries__lightbox');
  if (!dialog) return;

  var image     = dialog.querySelector('.laylo-pastries__lightbox-image');
  var nameEl    = dialog.querySelector('.laylo-pastries__lightbox-name');
  var descEl    = dialog.querySelector('.laylo-pastries__lightbox-desc');
  var closeBtn  = dialog.querySelector('.laylo-pastries__lightbox-close');
  var triggers  = section.querySelectorAll('.laylo-pastries__trigger');

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      // The full-size image is only ever requested here, on click — never
      // preloaded — so browsing the section with the mouse costs nothing
      // beyond the already-lazy-loaded gallery thumbnails.
      image.src = trigger.dataset.full || '';
      image.alt = trigger.dataset.alt || '';

      var name = trigger.dataset.name || '';
      var desc = trigger.dataset.desc || '';
      nameEl.textContent = name;
      nameEl.hidden = name === '';
      descEl.textContent = desc;
      descEl.hidden = desc === '';

      dialog.showModal();
    });
  });

  closeBtn.addEventListener('click', function () {
    dialog.close();
  });

  // A click that lands on the ::backdrop fires with event.target === the
  // dialog element itself (nothing else to hit) — this is the standard
  // click-outside-to-close technique for <dialog>, no extra hit-testing.
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) dialog.close();
  });
})();
